module.exports = __webpack_public_path__ + "static/media/c.e85538a5.svg";